var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.item.record),function(i){return _c('span',{key:i.key},[_c('i',{staticStyle:{"opacity":"0.5"}},[_vm._v(_vm._s(i.key)+" :")]),_c('span',[_vm._v(_vm._s(i.value))]),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }